import React from "react";

const VimeoPage = () => {
  return (
    <>
      <div className="salva-vimeo-video">
        <iframe
          src="https://player.vimeo.com/video/246699695?h=f2d20782e1"
          width="640"
          height="360"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </>
  );
};
export default VimeoPage;
